const config = {
  apiGateway: {
    REGION: 'us-west-2',
    PHY_LOCATION_APIGATEWAY_URL: 'https://7wvmtqo5ea.execute-api.us-west-2.amazonaws.com/prod',
    INTERNAL_PHY_LOCATION_APIGATEWAY_URL: 'https://trfc0judw3.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_APIGATEWAY_URL: 'https://1qrcp03hk8.execute-api.us-west-2.amazonaws.com/prod',
  },
  reactApp: {
    VERSION: 'taxonomy-physical-location-1.16.5',
    HOSTNAME: 'https://locations.barrick.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.barrick.forwoodsafety.com',
    WEBSOCKET: 'wss://i7rfamperj.execute-api.us-west-2.amazonaws.com/prod'
  },
};

export default config;